import styled from "styled-components";
import media from "constants/media";

import Container from "components/shared/container/Container";

export const FaqContainer = styled(Container)`
    width: 90%;
    margin: 24px auto 50px;
    padding: 0;

    ${media.mdUp`
        margin: 70px auto 0;
    `}
`;

export const Title = styled.h2`
    width: 100%;
    margin: 0 auto 26px;

    font-weight: normal;
    font-size: 20px;
    line-height: 25px;
    text-align: left;

    ${media.mdUp`
        font-size: 24px;
        line-height: 30px;
        text-align: center;
    `}
`;

export const Questions = styled.ul`
    list-style: none;

    ${media.mdUp`
        display: flex;
        align-items: stretch;
        margin: 0 -10px;
    `}
`;

export const Question = styled.li`
    display: flex;
    flex: 1;
    align-items: stretch;

    margin: 0 0 10px;

    ${media.mdUp`
        width: calc(33.3% - 20px);
        margin: 0 10px;
    `}
`;

export const StyledLink = styled.a`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 12px 20px;

    background: var(--color-athensGrey);
    border: 1px solid rgba(0, 23, 75, 0.1);

    svg {
        width: 18px;
        min-width: 18px;
        margin-top: 3px;

        transition: 0.3s all ease-in-out;

        ${media.mdUp`
            margin-top: 4px;
        `}
    }

    &:hover {
        svg {
            transform: translateX(3px);
        }
    }
`;

export const Text = styled.p`
    padding-right: 20px;

    font-size: 14px;
    line-height: 20px;

    ${media.mdUp`
        font-size: 15px;
        line-height: 25px;
    `}
`;
